import { ValidatieParameter } from "@models/claims";

// @dynamic
export class ValidatieregelHelper {
  static contains(parameters: ValidatieParameter[], typeValidatie: string): boolean {
    if (parameters == null) {
      return null;
    }

    return parameters.find(p => p.type_validatie === typeValidatie) !== null;
  }

  static get(parameters: ValidatieParameter[], typeValidatie: string): ValidatieParameter {
    if (parameters == null) {
      return null;
    }

    return parameters.find(p => p.type_validatie === typeValidatie);
  }
}
